import { Helmet } from 'react-helmet-async';
import './StaticPages.css';

export default function About() {
  return (
    <div className="static-page">
      <Helmet><title>About Us - MiniMom Co</title></Helmet>
      <div className="static-page-header">
        <h1>About MiniMom Co</h1>
        <p>Where little fashion meets big dreams</p>
      </div>
      <div className="static-page-content">
        <section className="static-section">
          <h2>Our Story</h2>
          <p>
            MiniMom Co was born from a simple idea — every child deserves clothing that's as vibrant and
            playful as they are. Founded by parents who were tired of choosing between style, comfort, and
            affordability, we set out to create a kids' fashion brand that delivers all three.
          </p>
          <p>
            What started as a small collection of handpicked essentials has grown into a full-range kids'
            fashion destination, loved by thousands of families across India.
          </p>
        </section>

        <section className="static-section">
          <h2>Our Mission</h2>
          <p>
            We believe childhood should be colourful, comfortable, and carefree. Our mission is to provide
            high-quality, trend-forward clothing for kids at prices that won't break the bank. Every piece
            in our collection is designed with little adventurers in mind — durable enough for the playground,
            stylish enough for every occasion.
          </p>
        </section>

        <section className="static-section">
          <h2>What Makes Us Different</h2>
          <div className="about-values">
            <div className="about-value-card">
              <span className="about-value-icon">🧵</span>
              <h3>Premium Fabrics</h3>
              <p>We use only soft, breathable, skin-friendly materials that are gentle on sensitive skin.</p>
            </div>
            <div className="about-value-card">
              <span className="about-value-icon">🎨</span>
              <h3>Trend-Forward Design</h3>
              <p>Our in-house design team creates collections inspired by global kids' fashion trends.</p>
            </div>
            <div className="about-value-card">
              <span className="about-value-icon">💰</span>
              <h3>Affordable Pricing</h3>
              <p>Quality fashion shouldn't cost a fortune. We keep our prices fair and transparent.</p>
            </div>
            <div className="about-value-card">
              <span className="about-value-icon">🌿</span>
              <h3>Sustainable Practices</h3>
              <p>We're committed to reducing our environmental footprint with eco-friendly packaging.</p>
            </div>
          </div>
        </section>

        <section className="static-section">
          <h2>Our Promise</h2>
          <p>
            Every order from MiniMom Co comes with our commitment to quality, fast shipping, easy returns,
            and a customer service team that truly cares. We're not just selling clothes — we're building a
            community of happy families.
          </p>
        </section>
      </div>
    </div>
  );
}
